module.exports = __webpack_public_path__ + "static/fulldomeComp2-1d3595256d1bddc9bee22e5ca1bc9fd4.png";